import { render } from "./ViewOptionModal.vue?vue&type=template&id=31d30493&scoped=true&ts=true"
import script from "./ViewOptionModal.vue?vue&type=script&lang=ts"
export * from "./ViewOptionModal.vue?vue&type=script&lang=ts"

import "./ViewOptionModal.vue?vue&type=style&index=0&id=31d30493&scoped=true&lang=css"

import exportComponent from "/home/runner/work/angelleague-front/angelleague-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31d30493"]])

export default __exports__